import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import {
  Container,
  ContainerType,
} from "src/app/shared/model/container.models";
import { CommonHttpService } from "src/app/shared/services/common-http/common-http.service";
import { MessageService } from "src/app/shared/services/message/message.service";
import {
  maxImageLength,
  Modalconfig,
  imageAllowedExtension,
  DefaultLanguageId,
  ScrollbarOptionslightXaxis,
} from "src/app/shared/constants";
import { Observable, Subject, Subscription, timer } from "rxjs";
import { ConfirmationModelComponent } from "src/app/shared/components/confirmation-model/confirmation-model.component";
import { PlaybookCommunicationService } from "../../services/playbook-communication.service";
import $ from "jquery";
import { sessionProfile } from "src/app/shared/interfaces/sessionStorageModel";
import { SessionStorageService } from "src/app/shared/services/session-storage/session-storage.service";
import {
  debounceTime,
  distinctUntilChanged,
  pairwise,
  retry,
  startWith,
  switchMap,
} from "rxjs/operators";
import { CommunicationService } from "src/app/shared/services/communication/communication.service";
import { CustomCompanyIcon } from "src/app/shared/model/playbook.models";
import { PlaybookCustomHeaders } from "src/app/shared/interfaces/responseBody";
import { DraftLiveDeleteComponent } from "../draft-live-delete/draft-live-delete.component";
import { findIndex } from "lodash";
import { PastePageSectionModalComponent } from "src/app/shared/components/paste-page-section-modal/paste-page-section-modal.component";

@Component({
    selector: "app-add-page",
    templateUrl: "./add-page.component.html",
    styleUrls: ["./add-page.component.scss"],
    standalone: false
})
export class AddPageComponent implements OnInit {
  verb;
  container: Container;
  playbookId;
  companyId;
  templateUrl: string;
  uploadedIconImg: string | ArrayBuffer = "";
  uploadedImg: string | ArrayBuffer = "";
  updateContainer = new Subject();
  removeContainer = new Subject();
  addContainer = new Subject();
  pasteContainer = new Subject();
  showProgress = false;
  progressPercent = 0;
  iconCount;
  iconArray = [];
  customIconArray: CustomCompanyIcon[] = [];
  isSubmit = false;
  addEditPageForm: UntypedFormGroup;
  draftLiveDeleteModalRef: BsModalRef;
  draftLiveDeleteModalSubsciber: Subscription;
  draftModalRef: BsModalRef;
  draftModalSubsciber: Subscription;

  @ViewChild("iconList") iconList: ElementRef<any>;

  copiedItem: ICopiedItem = {
    numberOfLanguages: 0,
    numberOfResources: 0,
    title: "",
    exists: false,
  };

  profileId: number;
  pageId;
  draftMode: boolean;
  defaultLanguageId = DefaultLanguageId;
  languageId: number;
  loggedInProfile: sessionProfile;
  private checkContainerStatus$: Observable<any>;
  private checkContainerStatusSubcription$: Subscription;
  scrollbarOptions = ScrollbarOptionslightXaxis;
  pageTemplateId = null;
  draftSections: Array<Container>;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private commonHttpService: CommonHttpService,
    private messageService: MessageService,
    private modalService: BsModalService,
    private commService: PlaybookCommunicationService,
    private communicationService: CommunicationService,
    private modalRef: BsModalRef,
    private sessionStorageService: SessionStorageService
  ) {}

  ngOnInit() {
    this.loggedInProfile =
      this.sessionStorageService.getLoggedInProfileDetail();
    if (this.languageId === this.defaultLanguageId) {
      this.isCopyPage();
      if (
        this.container.parentContainerId == null &&
        this.container.type === 1
      ) {
        this.getcustomIcons();
      }
    }
    if (this.draftMode === undefined) {
      this.draftMode = this.container.isDraftMode;
    }
    setTimeout(() => {
      this.figureIconCount();
    }, 1000);
    let group;
    if (this.container.type === 1) {
      group = {
        Title: [this.container.title, [Validators.required]],
      };
    } else {
      group = {
        Title: [this.container.title, [Validators.required]],
      };
    }
    this.addEditPageForm = this.formBuilder.group(group);
    this.titleChanges();
  }

  get formControls() {
    return this.addEditPageForm.controls;
  }

  titleChanges() {
    this.addEditPageForm
      .get("Title")
      .valueChanges.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        startWith(null as string),
        pairwise()
      )
      .subscribe(([prevTitleValue, titleValue]: [any, any]) => {
        if (prevTitleValue != titleValue) {
          this.addEditPageForm.patchValue({
            Title: this.addEditPageForm
              .get("Title")
              .value.replaceAll("\u000B", " "),
          });
        }
      });
  }

  figureIconCount() {
    let s: any = $(".sprite-image");
    if (s.length > 0) {
      const a = $("<div id='height-image'>");
      a.html(s);
      $("body").append(a);
      s = $("#height-image .sprite-image");
      const c = s.height() / 24;
      this.iconCount = c;
      this.iconArray = [];
      let ic = 1;
      while (ic <= c) {
        this.iconArray.push(ic);
        ic++;
      }
    }
  }

  /**
   * Get list of custom icons for company
   */
  getcustomIcons() {
    this.commonHttpService
      .get({
        uri: `/api/CompanyAssets/GetAllCompanyIcons?companyId=${this.companyId}`,
      })
      .subscribe((response: CustomCompanyIcon[]) => {
        this.customIconArray = response;
      });
  }

  /**
   * To set icon class to container object
   * @param iconNumber iconclass number
   */
  setIcon(iconNumber) {
    const selected = this.iconList.nativeElement.querySelector(
      `.page-icon-${iconNumber}`
    );
    if (selected.classList.contains("selected")) {
      this.container.iconClass = "";
      selected.classList.remove("select");
    } else {
      const selectedIcon =
        this.iconList.nativeElement.querySelector(`.selected`);
      selectedIcon != null ? selected.classList.remove("selected") : "";
      this.container.iconClass = iconNumber;
      if (this.container.customIconAssetId != null) {
        this.container.customIconAssetId = null;
        this.uploadedIconImg = null;
      }
    }
  }

  /**
   * To handle uploaded image in section
   */
  imageSelected(event, isImage) {
    const selectedFile = event.target.files[0] as File;
    if (selectedFile.size > maxImageLength) {
      this.messageService.showWarningMessage(
        "Image length must be lesser than 10mb"
      );
      return;
    }
    if (selectedFile) {
      this.showProgress = true;
      const mimeType = selectedFile.type;
      if (
        mimeType.match(/image\/*/) != null &&
        imageAllowedExtension.indexOf(mimeType.split("/").pop()) !== -1
      ) {
        const formData = new FormData() as any;
        formData.append("file", selectedFile);
        this.commonHttpService
          .postWithProgress({
            uri: "/api/Assets/UploadImage",
            object: formData,
          })
          .subscribe((response: any) => {
            if (typeof response === "number") {
              this.progressPercent = response;
            } else if (response) {
              const imgReader = new FileReader();
              imgReader.readAsDataURL(selectedFile);
              imgReader.onload = (e) => {
                if (isImage) {
                  this.uploadedImg = imgReader.result;
                  this.container.previewImageId = response.id;
                } else {
                  this.uploadedIconImg = imgReader.result;
                  this.container.customIconAssetId = response.id;
                  this.container.iconClass = null;
                }
                this.showProgress = false;
              };
            }
          });
      }
    } else {
      this.messageService.showWarningMessage(
        "Image type must be jpeg/jpg or png"
      );
    }
  }

  openFileDialog(isImage) {
    isImage
      ? $("#uploadImage").trigger("click")
      : $("#customIconImage").trigger("click");
  }

  /**
   * To remove image
   */
  removeImage(isImage) {
    if (isImage) {
      this.uploadedImg = "";
      this.container.previewImageId = null;
    } else {
      this.uploadedIconImg = "";
      this.container.customIconAssetId = null;
    }
  }

  /**
   * To set image src for uploaded section image
   */
  getImageSrc() {
    if (this.uploadedImg) {
      return this.uploadedImg;
    } else if (this.container.previewImageId) {
      return `/api/Assets/Image/${this.container.previewImageId}`;
    }
    return "";
  }

  /**
   * To set image src for uploaded custom icon image
   */
  getIconImageSrc() {
    if (this.uploadedIconImg) {
      return this.uploadedIconImg;
    } else if (this.container.customIconAssetId) {
      return `/api/Assets/Image/${this.container.customIconAssetId}`;
    }
    return "";
  }

  /**
   * To update data to database for add or edit container
   */
  addEditPage() {
    if (this.addEditPageForm.valid) {
      this.isSubmit = true;
      if (this.container.type !== 1) {
        this.container.isDraftMode = this.draftMode;
      }
      this.container.title = this.addEditPageForm
        .get("Title")
        .value.replaceAll("\u000B", " ");
      if (this.container.id > 0) {
        if (
          this.container.type === 1 &&
          this.container.isDraftMode !== this.draftMode &&
          this.container.isDraftMode
        ) {
          this.askForContinueWithDraft();
        } else {
          this.updateContainerApiCall();
        }
      } else {
        const reqObj = Object.assign({}, this.container, {
          playbookId: this.playbookId,
          companyId: this.companyId,
          pageTemplateId: this.pageTemplateId,
        });
        this.commonHttpService
          .post({
            uri: "/api/Containers/AddContainer",
            object: reqObj,
          })
          .subscribe((res) => {
            this.addContainer.next(res);
            setTimeout(() => {
              this.modalRef.hide();
              this.isSubmit = false;
            }, 100);
          });
      }
    }
  }

  askForContinueWithDraft() {
    const initialState = {
      msg: "Are you sure you want to move the page in draft mode ? Doing so will move all live sections in draft mode.",
    };
    this.draftModalRef = this.modalService.show(
      ConfirmationModelComponent,
      Object.assign({ initialState }, { class: "custom-modal" }, Modalconfig)
    );
    this.draftModalSubsciber = this.draftModalRef.content.onclose.subscribe(
      (isContinue: boolean) => {
        if (isContinue) {
          this.updateContainerApiCall();
        }
        this.draftModalRef.hide();
      }
    );
  }

  createHeaderObject(container: Container): PlaybookCustomHeaders {
    const obj: PlaybookCustomHeaders = new PlaybookCustomHeaders();
    obj.languageId = this.languageId;
    obj.playbookId = this.playbookId;
    obj.isdraftmode = this.draftMode;
    if (container.type === ContainerType.Page) {
      obj.pageId = container.id;
      obj.sectionId = null;
    } else if (container.type === ContainerType.Section) {
      obj.pageId = container.parentContainerId;
      obj.sectionId = container.id;
    }
    return obj;
  }

  updateContainerApiCall() {
    const reqObj = Object.assign({}, this.container, {
      playbookId: this.playbookId,
      companyId: this.companyId,
      languageId: this.languageId,
    });
    const headerObj = this.createHeaderObject(this.container);
    this.commonHttpService
      .putWithHeaders(
        {
          uri: "/api/Containers/UpdateContainer",
          object: reqObj,
        },
        headerObj
      )
      .subscribe((res: Container) => {
        res.isPoolingNeeded
          ? this.getContainerStatus(res)
          : this.updateContainer.next(res);
        setTimeout(() => {
          this.modalRef.hide();
          this.isSubmit = false;
        }, 100);
      });
  }

  getContainerStatus(res: Container) {
    this.communicationService.setShowHideLoader({
      loaderId: "simpleLoader",
      text: "",
      isShow: true,
    });
    this.unSubscribeCheckContainerStatus();
    this.checkContainerStatus$ = timer(1, 6000).pipe(
      switchMap(() => this.checkConatiner(res.playbookId)),
      retry(1)
    );
    this.checkContainerStatusSubcription$ =
      this.checkContainerStatus$.subscribe((response: any) => {
        if (response === "Complete") {
          this.unSubscribeCheckContainerStatus();
          this.updateContainer.next(res);
        } else if (response === "Error") {
          this.unSubscribeCheckContainerStatus();
          this.communicationService.setShowHideLoader({
            loaderId: "simpleLoader",
            text: "",
            isShow: false,
          });
        }
      });
  }

  unSubscribeCheckContainerStatus() {
    if (this.checkContainerStatusSubcription$) {
      this.checkContainerStatusSubcription$.unsubscribe();
    }
  }
  checkConatiner(playbookId: number): Observable<any> {
    return this.commonHttpService.get({
      uri: `/api/PlaybookDraft/GetDraftContainerStatus?playbookId=${playbookId}&pageId=${this.container.id}`,
    });
  }

  /**
   * To handle delete container
   */
  deleteContainer() {
    const isDraftSectionAvailaible = !this.container.isDraftMode
      ? findIndex(
          this.draftSections,
          (eachContainer) => eachContainer.refContainerId === this.container.id
        )
      : -1;
    const initialState = {
      msg:
        this.container.type === 2
          ? `Are you sure you would like to delete the section "${this.container.title}"?
       You will lose all the data in the section.`
          : `Are you sure you would like to delete the page "${this.container.title}"? You will lose all the data in the page.`,
      isSectionMsg:
        this.container.type === 2 && isDraftSectionAvailaible !== -1
          ? true
          : false,
    };
    this.draftLiveDeleteModalRef = this.modalService.show(
      DraftLiveDeleteComponent,
      Object.assign({ initialState }, { class: "custom-modal" }, Modalconfig)
    );
    this.draftLiveDeleteModalSubsciber =
      this.draftLiveDeleteModalRef.content.onclose.subscribe(
        ({ isDelete, deleteDraftSection }) => {
          this.draftLiveDeleteModalRef.hide();
          if (isDelete) {
            const reqObj = {
              id: this.container.id,
              playbookId: this.playbookId,
              companyId: this.companyId,
              pageTemplateId: this.pageTemplateId,
              deleteDraftSection: deleteDraftSection,
            };
            this.commonHttpService
              .deleteWithBodyWithHeaders(
                {
                  uri: "/api/Containers/Delete",
                  object: reqObj,
                  message: {
                    successMessage:
                      this.container.type === 2
                        ? deleteDraftSection && isDraftSectionAvailaible !== -1
                          ? "Live and draft section versions deleted successfully."
                          : "Section deleted successfully"
                        : "Page deleted successfully",
                  },
                },
                this.createHeaderObject(this.container)
              )
              .subscribe((res) => {
                if (res) {
                  this.removeContainer.next({
                    isDeleted: res,
                    isSection: this.container.type === 2,
                    deleteDraftSection: deleteDraftSection,
                  });
                }
              });
            this.modalRef.hide();
          }
          this.draftLiveDeleteModalSubsciber.unsubscribe();
        }
      );
  }

  copyCurrentSection() {
    this.commonHttpService
      .post({
        uri: `/api/Playbooks/CopyPlaybookSection`,
        object: {
          playbookId: this.playbookId,
          profileId: this.profileId,
          sectionId: this.container.id,
          pageTemplateId: this.pageTemplateId,
        },
        message: {
          showMessage: true,
          successMessage: "Section successfully copied to your clipboard.",
          errorMessage: "Something went wrong while Copying section.",
        },
      })
      .subscribe((response) => this.commService.setCopySectionExists(true));
  }

  onPasteCurrentPage() {
    if (
      !this.copiedItem.numberOfLanguages &&
      !this.copiedItem.numberOfResources
    ) {
      this.pasteCurrentPage({
        includeLanguages: false,
        includeResources: false,
      });
      return;
    }
    this.modalRef.setClass("d-none");

    const initialState = {
      copiedItem: this.copiedItem,
    };

    const pastePageModalRef = this.modalService.show(
      PastePageSectionModalComponent,
      Object.assign(
        {
          initialState,
        },
        { class: "custom-modal" },
        Modalconfig
      )
    );

    pastePageModalRef.content.onclose.subscribe(() => {
      this.modalRef.setClass("custom-modal");
      pastePageModalRef.hide();
    });

    pastePageModalRef.content.onsubmit.subscribe((d: { includeResources: boolean; includeLanguages: boolean }) => {
      this.pasteCurrentPage(d, pastePageModalRef);
    });
  }

  pasteCurrentPage(
    data: { includeResources: boolean; includeLanguages: boolean },
    modalRef?: BsModalRef
  ) {
    this.commonHttpService
      .post({
        uri: `/api/Playbooks/PasteCopiedPage`,
        object: {
          playbookId: this.playbookId,
          profileId: this.profileId,
          parentPageId: this.pageId,
          isDraftMode: this.container.isDraftMode,
          includeResources: data.includeResources,
          includeLanguages: data.includeLanguages,
        },
        message: {
          showMessage: true,
          errorMessage: "Something went wrong while Pasting page.",
          successMessage: "Page paste successfully.",
        },
      })
      .subscribe((response) => {
        this.pasteContainer.next(response);
        setTimeout(() => {
          if (modalRef) {
            modalRef.hide();
          }
          this.modalRef.hide();
        }, 100);
        this.commService.setUpdateLanguagesAfterPasteContent();
      });
  }

  onPasteCopiedSection() {
    if (
      !this.copiedItem.numberOfLanguages &&
      !this.copiedItem.numberOfResources
    ) {
      this.pasteCopiedSection({
        includeLanguages: false,
        includeResources: false,
      });
      return;
    }

    this.modalRef.setClass("d-none");

    const initialState = {
      copiedItem: this.copiedItem,
    };
    const pasteSectionModalRef = this.modalService.show(
      PastePageSectionModalComponent,
      Object.assign(
        {
          initialState,
        },
        { class: "custom-modal" },
        Modalconfig
      )
    );

    pasteSectionModalRef.content.onclose.subscribe(() => {
      this.modalRef.setClass("custom-modal");
      pasteSectionModalRef.hide();
    });

    pasteSectionModalRef.content.onsubmit.subscribe((d: { includeResources: boolean; includeLanguages: boolean }) => {
      this.pasteCopiedSection(d, pasteSectionModalRef);
    });
  }

  /**
   * Paste conversaton section copy
   */
  pasteCopiedSection(
    data: { includeResources: boolean; includeLanguages: boolean },
    modalRef?: BsModalRef
  ) {
    this.commonHttpService
      .post({
        uri: `/api/Playbooks/PasteCopiedSection`,
        object: {
          playbookId: this.playbookId,
          profileId: this.profileId,
          pageId: this.pageId,
          isDraftMode: this.draftMode,
          pageTemplateId: this.pageTemplateId,
          includeResources: data.includeResources,
          includeLanguages: data.includeLanguages,
        },
        message: {
          showMessage: true,
          errorMessage: "Something went wrong while Pasting section.",
          successMessage: "Section paste successfully.",
        },
      })
      .subscribe((response) => {
        this.pasteContainer.next(response);
        setTimeout(() => {
          if (modalRef) {
            modalRef.hide();
          }
          this.modalRef.hide();
        }, 100);
        this.commService.setUpdateLanguagesAfterPasteContent();
      });
  }

  closeAddPageModal() {
    this.modalRef.hide();
  }

  isCopyPage() {
    if (this.container.type === 1) {
      this.commonHttpService
        .get({
          uri: `/api/Playbooks/IsCopyPageExists?userId=${this.profileId}&playbookId=${this.playbookId}`,
        })
        .subscribe((copyPageData: any) => {
          this.copiedItem = {
            numberOfLanguages: copyPageData.numberOfLanguages,
            numberOfResources: copyPageData.numberOfResources,
            title: `Page | ${copyPageData.pageTitle}`,
            exists: copyPageData.isCopyPageExist,
          };

          this.commService.setCopyPageExists(copyPageData.isCopyPageExist);
        });
    } else {
      this.commonHttpService
        .get({
          uri: `/api/Playbooks/IsCopySectionExists?userId=${this.profileId}&playbookId=${this.playbookId}&pageTemplateId=${this.pageTemplateId}`,
        })
        .subscribe((copySectionData: any) => {
          this.copiedItem = {
            numberOfLanguages: copySectionData.numberOfLanguages,
            numberOfResources: copySectionData.numberOfResources,
            title: `Section | ${copySectionData.sectionTitle}`,
            exists: copySectionData.isCopySectionExist,
          };

          this.commService.setCopySectionExists(
            copySectionData.isCopySectionExist
          );
        });
    }
  }
  /**
   * Select custom company icon
   *
   * @param icon Custom company icon
   */
  selectCustomIcon(icon: CustomCompanyIcon) {
    this.container.customIconAssetId = icon.assetId;
  }

  copyCurrentPage() {
    this.commonHttpService
      .post({
        uri: `/api/Playbooks/CopyPlaybookPage`,
        object: {
          playbookId: this.playbookId,
          profileId: this.loggedInProfile.id,
          pageId: this.container.id,
        },
        message: {
          showMessage: true,
          successMessage: "Page successfully copied to your clipboard.",
          errorMessage: "Something went wrong while Copying page.",
        },
      })
      .subscribe((response) => this.commService.setCopyPageExists(true));
  }
}
interface ICopiedItem {
  numberOfLanguages: number;
  numberOfResources: number;
  title: string;
  exists: boolean;
}
